"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rootReducer = exports.rootEpic = void 0;
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _epics = require("./balance/epics");
var _reducer = require("./balance/reducer");
var _epics2 = require("./bet/epics");
var _epics3 = require("./loader/epics");
var _epics4 = require("./game/epics");
var _epics5 = require("./ui/epics");
var _epics6 = require("./sound/epics");
var _epics7 = require("./com/epics");
var _epics8 = require("./promotion/epics");
var _epics9 = require("./practice/epics");
var _epics10 = require("./autoPlay/epics");
var _epics11 = require("./featureBuy/epics");
var _epics12 = require("./replay/epics");
var _epics13 = require("./infoBar/epics");
var _reducer2 = require("./config/reducer");
var _reducer3 = require("./com/reducer");
var _reducer4 = require("./loader/reducer");
var _reducer5 = require("./ui/reducer");
var _reducer6 = require("./game/reducer");
var _reducer7 = require("./blitz/reducer");
var _reducer8 = require("./realityCheck/reducer");
var _reducer9 = require("./promotion/reducer");
var _reducer10 = require("./practice/reducer");
var _reducer11 = require("./autoPlay/reducer");
var _reducer12 = require("./featureBuy/reducer");
var _reducer13 = require("./replay/reducer");
var _reducer14 = require("./infoBar/reducer");
var _epics14 = require("./realityCheck/epics");
var _epics15 = require("./blitz/epics");
var _epics16 = require("./engage/epics");
var _epics17 = require("./config/epics");
var _reducer15 = require("./bet/reducer");
var _soundReducer = require("./sound/soundReducer");
var rootEpic = exports.rootEpic = function rootEpic(action$, store$, dependencies) {
  return (0, _reduxObservable.combineEpics)(
  // Add our default epics.
  _epics.balanceEpics, _epics2.betEpics, new _epics3.LoaderEpic().getEpic(), new _epics4.GameEpic().getEpic(), new _epics5.UiEpic().getEpic(), new _epics6.SoundEpic().getEpic(), new _epics7.ComEpics().getEpic(), new _epics17.ConfigEpic().getEpic(), new _epics15.BlitzEpic().getEpic(), new _epics16.EngageEpic().getEpic(), new _epics14.RealityCheckEpic().getEpic(), new _epics8.PromotionEpic().getEpic(), new _epics9.PracticeEpic().getEpic(), new _epics10.AutoPlayEpic().getEpic(), new _epics11.FeatureBuyEpic().getEpic(), new _epics12.ReplayEpic().getEpic(), new _epics13.InfoBarEpic().getEpic())(action$, store$, dependencies).pipe((0, _rxjs.catchError)(function (error, source) {
    console.error(error);
    return source;
  }));
};

// add our default reducers
var rootReducer = exports.rootReducer = {
  balance: _reducer.balanceReducer,
  config: _reducer2.configReducer,
  bet: _reducer15.betReducer,
  com: _reducer3.comReducer,
  loader: _reducer4.loaderReducer,
  ui: _reducer5.uiReducer,
  game: _reducer6.gameReducer,
  blitz: _reducer7.blitzReducer,
  responsibleGaming: _reducer8.responsibleGamingReducer,
  promotion: _reducer9.promotionReducer,
  practice: _reducer10.practiceReducer,
  autoPlay: _reducer11.autoPlayReducer,
  sound: _soundReducer.soundReducer,
  featureBuy: _reducer12.featureBuyReducer,
  replay: _reducer13.replayReducer,
  infoBar: _reducer14.infoBarReducer
};
/**
 * Defines default state with all default reducers that are shared between all games.
 */
//# sourceMappingURL=root.js.map